import { NOTIFICATION_TYPE } from "../data/enums"
import { getNavigateToLink as getNavigateToJobLink } from "./useJobUtils"

const useNotificationUtils = () => {
  const getNavigateToLink = (notification) => {
    switch (notification.type) {
      case NOTIFICATION_TYPE.POST:
      case NOTIFICATION_TYPE.POST_COMMENT_MENTION:
        return `/hub/post/${notification?.post?.id || "unknown"}`
      case NOTIFICATION_TYPE.ACTION:
        return `/hub/action/${notification?.action?.id || "unknown"}`
      case NOTIFICATION_TYPE.OBSERVATION:
        if (!notification?.userTraining?.id) {
          return "/training/courses"
        }
        return `/training/courses/${notification?.userTraining?.id}`
      case NOTIFICATION_TYPE.TRAINING:
        if (!notification?.userTraining?.id) {
          return "/training/courses"
        }
        return `/training/courses/${notification?.userTraining?.id}`
      case NOTIFICATION_TYPE.ACCREDITATION:
        return "/account/accreditation"
      case NOTIFICATION_TYPE.JOB:
        return getNavigateToJobLink(notification.job)
      case NOTIFICATION_TYPE.WORKFLOW:
        return `/hazards-incidents/report/${notification?.workflow?.id || "unknown"}`
      default:
    }
  }

  return {
    getNavigateToLink
  }
}

export { useNotificationUtils }
